import React from "react";
import styled from "styled-components";
import theme from "../../../../util/theme";
import { AppText } from "../../../ui";

interface TextQuestionProps {
  title: string;
  textAlign?: "left" | "center" | "right";
  color?: string;
}

const TextQuestion: React.FC<TextQuestionProps> = ({ title, textAlign = "left", color }) => {
  return (
    <TextQuestionContainer>
      <AppText
        color={color ?? theme.WHITE_COLOR}
        fontSize={24}
        mobileFontSize={20}
        textAlign={textAlign}
        style={{ maxWidth: 392 }}
      >
        {title}
      </AppText>
    </TextQuestionContainer>
  );
};

const TextQuestionContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export default TextQuestion;
